import {Component, Input} from "@angular/core";
import {MenuEvents} from "../../../menu/menu-events";
import {MenuDietaryIndicatorsData, MenuSellableData} from "../../../menu/menu-entity.model";

@Component({
    selector: "woa-dietary-panel",
    templateUrl: "./dietary-panel.component.html"
})
export class DietaryPanelComponent {
    MenuEvents = MenuEvents;

    @Input() sellable: MenuSellableData;

    trackIndicatorByFn(index, dietaryIndicator: MenuDietaryIndicatorsData): number {
        return dietaryIndicator.id;
    }

    getDisplayedIndicatorCode(indicator: MenuDietaryIndicatorsData): string {
        return indicator.code.substring(0, 3);
    }

    tooltipLeft(icon: HTMLElement, label: HTMLElement): boolean {
        return (window.innerWidth - icon.getBoundingClientRect().right) < label.getBoundingClientRect().width + 5;
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/dietary-panel/dietary-panel.component.ts